import axios from 'axios';
import { ref, watch } from 'vue';

const KEY = 'preferences';
const prefs = localStorage.getItem(KEY);
const prefsObj = parse(prefs) ?? {};

function parse(s) {
    try { return JSON.parse(s) }
    catch { }
}

function clear() {
    localStorage.removeItem(KEY);
}

function read(key, defVal) {
    return prefsObj[key] ?? defVal;
}

function write(key, value) {
    prefsObj[key] = value;
    localStorage.setItem(KEY, JSON.stringify(prefsObj));
}

const notifications = ref(read('notifications', true));
watch(notifications, async (value) => {
    write('notifications', value);
});

const theme = ref(document.body.classList.contains('bg-dark') ? 1 : 0);
watch(theme, async (value) => {
    const l = document.body.classList;
    if (value === 0) {
        l.remove('bg-dark');
        l.add('bg-light');
    } else {
        l.remove('bg-light');
        l.add('bg-dark');
    }
    axios.post('/users/theme', { value });
});

const Preferences = {
    notifications,
    theme,
    clear
};


export default Preferences